<section>
    <div class="error-message">
        <div class="main-title">
            <h1>{{ title }}</h1>
            <h2>{{ subMainTitle }}</h2>
        </div>
        <div class="content">
            <img [src]="'/assets/images/direct-debit/' + icon" alt="" class="icon" />
            <div class="show-time-over">
                <h2>{{ subtitle }}</h2>
                <p [innerHtml]="message"></p>
            </div>

            <div class="button-wrapper">
                <a (click)="next()" class="brand-button aqua-button" title="" id="retry"
                    ><span>{{ btn }}</span></a
                >
                <a *ngIf="showLink" class="link" title="" (click)="linkClick()"
                    ><span>{{ link }}</span></a
                >
            </div>
        </div>
    </div>
</section>
